import axios from "axios";

import type {FetchNUXSettingsResponse} from "@songfinch/types";

const getBaseUrl = () => {
    return `${window.location.origin}/v3/api`;
};

export async function fetchNUXSettings(): Promise<FetchNUXSettingsResponse> {
    const res = await axios.get<FetchNUXSettingsResponse>(`/new_user_experience_settings`, {baseURL: getBaseUrl()});
    return res.data;
}


export async function updateNUXSettings(placementId: string): Promise<FetchNUXSettingsResponse> {
    const res = await axios.put<FetchNUXSettingsResponse>(
        `/new_user_experience_settings/${placementId}`, 
        undefined, 
        {baseURL: getBaseUrl()}
    );
    return res.data;
}